import { MemberStripeCustomerSearchFilter } from 'src/modules/invoice/models/memberStripeCustomerSearchFilter';
import { StripeCustomer } from 'src/modules/member/models/member';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';

const controller = 'StripeCustomer';

export const getAllMemberStripeCustomer = (filter: MemberStripeCustomerSearchFilter) => {
  return AxiosInstance.get<PagedResult<StripeCustomer>>(`${controller}`, { params: filter });
};

export const getMemberStripeCustomerById = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<StripeCustomer>(endpoint);
};

export const createMemberStripeCustomer = (data: StripeCustomer) => {
  return AxiosInstance.post<StripeCustomer>(controller, data);
};

export const updateMemberStripeCustomer = (data: StripeCustomer) => {
  const endpoint = `${controller}`;
  return AxiosInstance.put<StripeCustomer>(endpoint, data);
};

export const deleteMemberStripeCustomer = (id: number) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.delete(endpoint);
};
